module.exports = __webpack_public_path__ + "img/8dys-03.5a02e671.png";